/**
 * Canonical route ids and hash strings for Earth 3.0.
 * Hashes MUST remain #<route> (never #/<route>).
 */
export const ROUTE_IDS = [
  "field",
  "stellar",
  "earth2",
  "stars",
  "earth3",
  "practice",
  "sources",
] as const;

export type RouteId = (typeof ROUTE_IDS)[number];

/** Empty / unknown hashes land on the Field Guide index. */
export const DEFAULT_ROUTE: RouteId = "field";

export const ROUTE_TITLES: Record<RouteId, string> = {
  field: "The Field",
  stellar: "Stellar",
  earth2: "Earth 2.0",
  stars: "I Eat the Stars",
  earth3: "Earth 3.0",
  practice: "The Practice",
  sources: "Evidence",
};

export function isRouteId(value: string): value is RouteId {
  return (ROUTE_IDS as readonly string[]).includes(value);
}

export function parseRouteHash(hash: string): RouteId {
  const raw = hash.startsWith("#") ? hash.slice(1) : hash;
  // Reject slash-prefixed hashes (#/earth3) by stripping a single leading slash only for detection
  if (raw.startsWith("/")) {
    const stripped = raw.slice(1).split(/[/?#]/)[0] ?? "";
    if (isRouteId(stripped)) return stripped;
    return DEFAULT_ROUTE;
  }
  const id = raw.split(/[/?#]/)[0] ?? "";
  return isRouteId(id) ? id : DEFAULT_ROUTE;
}

export function routeHash(id: RouteId): string {
  return `#${id}`;
}
